<template>
  <div class="hciIndex">
    <div class="feil_menu">
      <div class="feil_menu_title">HCI</div>
      <div class="feil_menu_item">
        <el-tree
          :data="feilListData"
          node-key="id"
          :props="defaultProps"
          @node-click="handleNodeClick"
          :default-expanded-keys="unfoldArr"
          accordion
          :highlight-current="true"
          ref="tree"
        >
        <span class="span-ellipsis" slot-scope="{ node, data }">
        <span :title="node.label">{{ node.label }}</span>
        </span>
        </el-tree>
      </div>
    </div>
    <div class="feil_main">
      <div class="feil_main_title">{{this.mainTitle}}</div>
      <div class="feil_main_item" v-if="fileMainItemData&&fileMainItemData.length>0">
        <ul class="feil_main_item_ul">
          <li v-for="val in this.fileMainItemData" :key="val.id" class="feil_main_item_li">
            <div class="content" @click="downFeil(val.fileUrl,val.fileType)">
              <div class="content_icon">
                <img
                  :src="fileImg.ppt"
                  alt="ppt"
                  v-if="val.fileType == 'pptx'"
                />
                <img
                  :src="fileImg.doc"
                  alt="doc"
                  v-else-if="val.fileType == 'doc'"
                />
                <img
                  :src="fileImg.pdf"
                  alt="pdf"
                  v-else-if="val.fileType == 'pdf'"
                />
                <svg-icon
                  icon-class="image"
                  v-else-if="val.fileType == 'jpg' || val.fileType == 'png'"
                />
                <svg-icon icon-class="XLS" v-else-if="val.fileType == 'xlsx'" />
                <svg-icon
                  icon-class="video"
                  v-else-if="val.fileType == 'video'"
                />
                <svg-icon
                  icon-class="link"
                  v-else-if="val.fileType == 'link'"
                />
              </div>
              <div class="content_title">
                <p>{{ val.fileName }}</p>
              </div>
              <div class="content_down">
                <svg-icon icon-class="download" v-if="val.fileType != 'link'&&val.fileType != 'video'" />
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div class="feil_main_item" v-else>
        <div class="noDetail">
          <svg-icon icon-class="nodeta"/>
          <p>No Data</p>
        </div>
      </div>
      <el-pagination layout="prev, pager, next" :total="pagination.total" :page-size="pagination.pageSize" @current-change="handleCurrentChange">
      </el-pagination>
    </div>
  </div>
</template>

<script>
import { getCurrentHost } from '@/utils/index.js'
export default {
  name: "hciIndex",
  data() {
    return {
      showItem:1,
      mainTitle:'Product Videos',
      unfoldArr:[1],
      pagination:{
        page:0,
        pageSize:8,
        total:0,
        data:[]
      },
      fileMainItemData:[],
      feilListData: [
        {
          label: "Product Introduction",
          id: 1,
          children: [
            { label: "Product Videos", child_id: 1, id: 20 },
            { label: "HCI Main Slide", child_id: 2 },
            { label: "HCI Online Demo", child_id: 3 },
            { label: "NG-CDI Main Slide", child_id: 4 },
            { label: "PaaS (KubeManager)", child_id: 5 },
          ],
        },
        {
          label: "Sales Guidance",
          id: 2,
          children: [
            { label: "Sales Guide in 2021", child_id: 6 },
            { label: "Sales Scenario", child_id: 7 },
            { label: "BO Discovery", child_id: 8 },
            { label: "Sangfor HCI Partner Development Guide", child_id: 9 },
            { label: "Partner Opportunity Discovery Book", child_id: 10 },
            { label: "Case  Study,  Case Book", child_id: 11 },
            { label: "Brochure", child_id: 12 },
            { label: "Interview and Branding Videos", child_id: 13 },
          ],
        },
        {
          label: "Battle Card",
          id: 3,
          children: [{ label: "Sales Battle Cards", child_id: 14 }],
        },
        {
          label: "Sizing Guide",
          id: 4,
          children: [{ label: "Sizing Guide", child_id: 15 }],
        },
        {
          label: "POC Docs",
          id: 5,
          children: [
            { label: "Best Practices", child_id: 16 },
            { label: "Compatibility List", child_id: 17 },
            { label: "Testing Guide", child_id: 18 },
            { label: "POC Document Templates", child_id: 19 },
            { label: "User Manual", child_id: 20 },
          ],
        },
        {
          label: "Bidding Doc",
          id: 6,
          children: [{ label: "Tender Specs", child_id: 21 }],
        },
        {
          label: "Technical Material",
          id: 7,
          children: [
            { label: "Feature List", child_id: 22 },
            { label: "Solution Proposal", child_id: 23 },
            { label: "TCO Analysis", child_id: 24 },
            { label: "Technical White Paper", child_id: 25 },
            { label: "Disaster Recovery", child_id: 26 },
          ],
        },
        {
          label: "Training Docs",
          id: 8,
          children: [
            { label: "Partner Training", child_id: 27 },
            { label: "Practice Experience Sharing", child_id: 28 },
          ],
        },
      ],
      defaultProps: {
        children: "children",
        label: "label",
      },
      feilIndexData: {
        1:[
          {
            id:1,
            fileName:'Product  videos',
            fileUrl:'https://www.facebook.com/watch/?v=318819602058646',
            fileType:'video',
          },
        ],
        2:[
          {
            id:1,
            fileName:'Sangfor aCloud Technical Main Slides 201810.pptx',
            fileUrl:'Sangfor aCloud Technical Main Slides 201810.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'Sangfor HCI Enterprise Applications Solution 2020 rev.pptx',
            fileUrl:'Sangfor HCI Enterprise Applications Solution 2020 rev.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Sangfor HCI Main Slides _20201112.pptx',
            fileUrl:'Sangfor HCI Main Slides _20201112.pptx',
            fileType:'pptx',
          },
          {
            id:4,
            fileName:'Sangfor HCI New Main Slides _20210428.pptx',
            fileUrl:'Sangfor HCI New Main Slides _20210428.pptx',
            fileType:'pptx',
          },
        ],
        3:[],
        4:[
          {
            id:1,
            fileName:'Sangfor New HCI Sales Pitch Summary.pdf',
            fileUrl:'Sangfor New HCI Sales Pitch Summary.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'Sangfor NG-CDI Main Slides _20210428.pptx',
            fileUrl:'Sangfor NG-CDI Main Slides _20210428.pptx',
            fileType:'pptx',
          },
        ],
        5:[
          {
            id:1,
            fileName:'[FINAL] Container_Cloud Breakout Session.pptx',
            fileUrl:'[FINAL] Container_Cloud Breakout Session.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'Competitive Analysis-PaaS V00.xlsx',
            fileUrl:'Competitive Analysis-PaaS V00.xlsx',
            fileType:'xlsx',
          },
          {
            id:3,
            fileName:'Container_PP_P_Container Basic Knowledge_20200924 R2.pptx',
            fileUrl:'Container_PP_P_Container Basic Knowledge_20200924 R2.pptx',
            fileType:'pptx',
          },
          {
            id:4,
            fileName:'Feature List_SKM_20200615.xlsx',
            fileUrl:'Feature List_SKM_20200615.xlsx',
            fileType:'xlsx',
          },
          {
            id:5,
            fileName:'KubeManager Configuration Tool.xlsx',
            fileUrl:'KubeManager Configuration Tool.xlsx',
            fileType:'xlsx',
          },
          {
            id:6,
            fileName:'Paas_BR_P_Sangfor PaaS Sales Guide_20210115.pdf',
            fileUrl:'Paas_BR_P_Sangfor PaaS Sales Guide_20210115.pdf',
            fileType:'pdf',
          },
          {
            id:7,
            fileName:'Sangfor KubeManager Tender Specs v1.docx',
            fileUrl:'Sangfor KubeManager Tender Specs v1.docx',
            fileType:'doc',
          },
          {
            id:8,
            fileName:'Sangfor PaaS Competitive Landscape_v1.pptx',
            fileUrl:'Sangfor PaaS Competitive Landscape_v1.pptx',
            fileType:'pptx',
          },
          {
            id:9,
            fileName:'Sangfor PaaS Platform (KubeManager) White Paper v1.0.pdf',
            fileUrl:'Sangfor PaaS Platform (KubeManager) White Paper v1.0.pdf',
            fileType:'pdf',
          },
          {
            id:10,
            fileName:'Sangfor PaaS Platform Testing Guide V1.0.pdf',
            fileUrl:'Sangfor PaaS Platform Testing Guide V1.0.pdf',
            fileType:'pdf',
          },
          {
            id:11,
            fileName:'Sangfor PaaS Solution Main Slides_20210115.pptx',
            fileUrl:'Sangfor PaaS Solution Main Slides_20210115.pptx',
            fileType:'pptx',
          },
          {
            id:12,
            fileName:'Sangfor_PaaS_Solution_KubeManager_Brochure 20210128.pdf',
            fileUrl:'Sangfor_PaaS_Solution_KubeManager_Brochure 20210128.pdf',
            fileType:'pdf',
          },
          {
            id:13,
            fileName:'Understand k8s related technologies and opportunities in 30mins.pdf',
            fileUrl:'Understand k8s related technologies and opportunities in 30mins.pdf',
            fileType:'pdf',
          },
          {
            id:14,
            fileName:'User Manual of Sangfor PaaS–KubeManager 1.0.pdf',
            fileUrl:'User Manual of Sangfor PaaS–KubeManager 1.0.pdf',
            fileType:'pdf',
          },
        ],
        6:[
          {
            id:1,
            fileName:'Sangfor aCloud Sales Guide _2020.pdf',
            fileUrl:'Sangfor aCloud Sales Guide _2020.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:"Sales guide of New concept and solutions for customer’s digital transformation2021.docx",
            fileUrl:"Sales guide of New concept and solutions for customer’s digital transformation2021.docx",
            fileType:'doc',
          },
        ],
        7:[
          {
            id:1,
            fileName:'Sangfor aCloud Sales Scenarios &amp;amp; Success Stories 201909.pptx',
            fileUrl:'Sangfor aCloud Sales Scenarios &amp;amp; Success Stories 201909.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'Some updates on aCloud market and sales scenarios.pptx',
            fileUrl:'Some updates on aCloud market and sales scenarios.pptx',
            fileType:'pptx',
          },
        ],
        8:[
          {
            id:1,
            fileName:'How to identify HCI BO.pptx',
            fileUrl:'How to identify HCI BO.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'Sangfor HCI Chalk Talk.pptx',
            fileUrl:'Sangfor HCI Chalk Talk.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Sangfor HCI Communication Talking Points.docx',
            fileUrl:'Sangfor HCI Communication Talking Points.docx',
            fileType:'doc',
          },
        ],
        9:[
          {
            id:1,
            fileName:'Sangfor HCI partner development guidance_20170705.pptx',
            fileUrl:'Sangfor HCI partner development guidance_20170705.pptx',
            fileType:'pptx',
          },
        ],
        10:[
          {
            id:1,
            fileName:'Partner discovery guide - enable cloud experience.pdf',
            fileUrl:'Partner discovery guide - enable cloud experience.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'Partner discovery guide - improve ROI reduce TCO.pdf',
            fileUrl:'Partner discovery guide - improve ROI reduce TCO.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'Partner Opportunity Discovery Guide - rapid time to market and deployment.pdf',
            fileUrl:'Partner Opportunity Discovery Guide - rapid time to market and deployment.pdf',
            fileType:'pdf',
          },
        ],
        11:[
          {
            id:1,
            fileName:'HCI案例集-20210520.pdf',
            fileUrl:'HCI案例集-20210520.pdf',
            fileType:'pdf',
          },
        ],
        12:[
          {
            id:1,
            fileName:'Capsule Data Center Based on HCI-20210225.pdf',
            fileUrl:'Capsule Data Center Based on HCI-20210225.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'Data Center Transformation with Sangfor HCI A4.pdf',
            fileUrl:'Data Center Transformation with Sangfor HCI A4.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'HCI_BR_P_HCI-Brochure_20200927.pdf',
            fileUrl:'HCI_BR_P_HCI-Brochure_20200927.pdf',
            fileType:'pdf',
          },
          {
            id:4,
            fileName:'HCI_DS_P_Sangfor HCI DataSheet_20200927.pdf',
            fileUrl:'HCI_DS_P_Sangfor HCI DataSheet_20200927.pdf',
            fileType:'pdf',
          },
          {
            id:5,
            fileName:'How Hospitals Benefit from Hyper-Converged Infrastructure final.pdf',
            fileUrl:'How Hospitals Benefit from Hyper-Converged Infrastructure final.pdf',
            fileType:'pdf',
          },
          {
            id:6,
            fileName:'Sangfor aCloud Disaster Recovery Solution 20181017.pdf',
            fileUrl:'Sangfor aCloud Disaster Recovery Solution 20181017.pdf',
            fileType:'pdf',
          },
          {
            id:7,
            fileName:'Sangfor aCMP 20180930.pdf',
            fileUrl:'Sangfor aCMP 20180930.pdf',
            fileType:'pdf',
          },
          {
            id:8,
            fileName:'Sangfor Education Solution 20181122.pdf',
            fileUrl:'Sangfor Education Solution 20181122.pdf',
            fileType:'pdf',
          },
          {
            id:9,
            fileName:'Sangfor Education Solution Brochure.pdf',
            fileUrl:'Sangfor Education Solution Brochure.pdf',
            fileType:'pdf',
          },
          {
            id:10,
            fileName:'Sangfor HCI for Enterprise Applications-v3.pdf',
            fileUrl:'Sangfor HCI for Enterprise Applications-v3.pdf',
            fileType:'pdf',
          },
        ],
        13:[
          {
            id:1,
            fileName:'Interview and branding videos',
            fileUrl:'https://www.sangfor.com/en/products/cloud-computing/hyper-converged-infrastructure',
            fileType:'video',
          },
        ],
        14:[
          {
            id:1,
            fileName:'Disaster Recovery Competition Analysis for aCloud 5.8.6 (for internal sharing).pdf',
            fileUrl:'Disaster Recovery Competition Analysis for aCloud 5.8.6 (for internal sharing).pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'HCI Competitive Analysis v.s. H3C v1.pdf',
            fileUrl:'HCI Competitive Analysis v.s. H3C v1.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'HCI Competitive Analysis v.s. VMware &amp;amp; Nutanix 2021.pdf',
            fileUrl:'HCI Competitive Analysis v.s. VMware &amp;amp; Nutanix 2021.pdf',
            fileType:'pdf',
          },
          {
            id:4,
            fileName:'Sangfor aCloud Detailed Competition Analysis 202003.pdf',
            fileUrl:'Sangfor aCloud Detailed Competition Analysis 202003.pdf',
            fileType:'pdf',
          },
          {
            id:5,
            fileName:'Sangfor aCloud vs Windows S2D 20190428.docx',
            fileUrl:'Sangfor aCloud vs Windows S2D 20190428.docx',
            fileType:'doc',
          },
          {
            id:6,
            fileName:'Sangfor HCI Feature comparison VS Nutanix &amp;amp; VMware-2021.pdf',
            fileUrl:'Sangfor HCI Feature comparison VS Nutanix &amp;amp; VMware-2021.pdf',
            fileType:'pdf',
          },
        ],
        15:[
          {
            id:1,
            fileName:'Sangfor HCI Advanced Sizing &amp;amp; Quotation 202011.pptx',
            fileUrl:'Sangfor HCI Advanced Sizing &amp;amp; Quotation 202011.pptx',
            fileType:'pptx',
          },
        ],
        16:[
          {
            id:1,
            fileName:'aCloud_v5.8.8 High Availability Best Practice-v2.pdf',
            fileUrl:'aCloud_v5.8.8 High Availability Best Practice-v2.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'aCloud_v5.8.8_High Performance Best Practice.pdf',
            fileUrl:'aCloud_v5.8.8_High Performance Best Practice.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'Oracle RAC Best Practice on Sangfor HCI.pdf',
            fileUrl:'Oracle RAC Best Practice on Sangfor HCI.pdf',
            fileType:'pdf',
          },
          {
            id:4,
            fileName:'Protect Your Data on Sangfor HCI with Arcserve.pdf',
            fileUrl:'Protect Your Data on Sangfor HCI with Arcserve.pdf',
            fileType:'pdf',
          },
          {
            id:5,
            fileName:'Sangfor aCloud Best Practice for SAP Business 1.pdf',
            fileUrl:'Sangfor aCloud Best Practice for SAP Business 1.pdf',
            fileType:'pdf',
          },
          {
            id:6,
            fileName:'SAP HANA Best Practice on Sangfor HCI.pdf',
            fileUrl:'SAP HANA Best Practice on Sangfor HCI.pdf',
            fileType:'pdf',
          },
        ],
        17:[
          {
            id:1,
            fileName:'Sangfor HCI Compatibility List 20210524.xls',
            fileUrl:'Sangfor HCI Compatibility List 20210524.xls',
            fileType:'xlsx',
          },
        ],
        18:[
          {
            id:1,
            fileName:'Sangfor aCloud Disaster Recovery Testing Guide ver5.8.6.docx',
            fileUrl:'Sangfor aCloud Disaster Recovery Testing Guide ver5.8.6.docx',
            fileType:'doc',
          },
          {
            id:2,
            fileName:'Sangfor_HCI_V5.8.3_CDP Testing Guide_20180202.pdf',
            fileUrl:'Sangfor_HCI_V5.8.3_CDP Testing Guide_20180202.pdf',
            fileType:'pdf',
          },
          {
            id:3,
            fileName:'Sangfor_HCI_V5.8.3_VMware Migration &amp;amp; Backup Testing Guide_20180202.pdf',
            fileUrl:'Sangfor_HCI_V5.8.3_VMware Migration &amp;amp; Backup Testing Guide_20180202.pdf',
            fileType:'pdf',
          },
          {
            id:4,
            fileName:'SCP open-api_Eng.Ver- Overview &amp;amp; user guide.docx',
            fileUrl:'SCP open-api_Eng.Ver- Overview &amp;amp; user guide.docx',
            fileType:'doc',
          },
        ],
        19:[
          {
            id:1,
            fileName:'Sangfor aCloud POC Plan--Template 20190428.docx',
            fileUrl:'Sangfor aCloud POC Plan--Template 20190428.docx',
            fileType:'doc',
          },
          {
            id:2,
            fileName:'Sangfor aCloud POC Reporting Template20190428.pptx',
            fileUrl:'Sangfor aCloud POC Reporting Template20190428.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Sangfor aCloud POC survey table.xlsx',
            fileUrl:'Sangfor aCloud POC survey table.xlsx',
            fileType:'xlsx',
          },
        ],
        20:[
          {
            id:1,
            fileName:'SANGFOR_HCI_v6.1.0_User Manual.pdf',
            fileUrl:'SANGFOR_HCI_v6.1.0_User Manual.pdf',
            fileType:'pdf',
          },
          {
            id:2,
            fileName:'SANGFOR_SCP_v6.1.0_ User Manual.pdf',
            fileUrl:'SANGFOR_SCP_v6.1.0_ User Manual.pdf',
            fileType:'pdf',
          },
        ],
        21:[
          {
            id:1,
            fileName:'Sangfor HCI &amp;amp; SCP Tender Specs 20201015.xlsx',
            fileUrl:'Sangfor HCI &amp;amp; SCP Tender Specs 20201015.xlsx',
            fileType:'xlsx',
          },
        ],
        22:[
          {
            id:1,
            fileName:'HCI &amp;amp; SCP 6.1.0 Feature List (20200610).xlsx',
            fileUrl:'HCI &amp;amp; SCP 6.1.0 Feature List (20200610).xlsx',
            fileType:'xlsx',
          },
          {
            id:2,
            fileName:'HCI &amp;amp; SCP 6.2.0 Feature List (20201102).xlsx',
            fileUrl:'HCI &amp;amp; SCP 6.2.0 Feature List (20201102).xlsx',
            fileType:'xlsx',
          },
        ],
        23:[
          {
            id:1,
            fileName:'Sangfor aCloud Disaster Recovery Solution Proposal 20190211.docx',
            fileUrl:'Sangfor aCloud Disaster Recovery Solution Proposal 20190211.docx',
            fileType:'doc',
          },
          {
            id:2,
            fileName:'Sangfor HCI DC Solution Proposal -20170809.docx',
            fileUrl:'Sangfor HCI DC Solution Proposal -20170809.docx',
            fileType:'doc',
          },
          {
            id:3,
            fileName:'Sangfor HCI SolutionTechnical Proposal 1214-Detailed.doc',
            fileUrl:'Sangfor HCI SolutionTechnical Proposal 1214-Detailed.doc',
            fileType:'doc',
          },
        ],
        24:[
          {
            id:1,
            fileName:'Sangfor HCI TCO Analysis v.s. 3-tier Infrastructure 2018Q2.pdf',
            fileUrl:'Sangfor HCI TCO Analysis v.s. 3-tier Infrastructure 2018Q2.pdf',
            fileType:'pdf',
          },
        ],
        25:[
          {
            id:1,
            fileName:'aCloud 5.8.6 aCMP White Paper.docx',
            fileUrl:'aCloud 5.8.6 aCMP White Paper.docx',
            fileType:'doc',
          },
          {
            id:2,
            fileName:'aCloud 5.8.6 DR White Paper.docx',
            fileUrl:'aCloud 5.8.6 DR White Paper.docx',
            fileType:'doc',
          },
          {
            id:3,
            fileName:'aCloud vGPU white paper.docx',
            fileUrl:'aCloud vGPU white paper.docx',
            fileType:'doc',
          },
          {
            id:4,
            fileName:'Backup Solution for VMs in vCenter White Paper.pdf',
            fileUrl:'Backup Solution for VMs in vCenter White Paper.pdf',
            fileType:'pdf',
          },
          {
            id:5,
            fileName:'Sangfor aSAN 5.8.6 Technical White Paper.pdf',
            fileUrl:'Sangfor aSAN 5.8.6 Technical White Paper.pdf',
            fileType:'pdf',
          },
          {
            id:6,
            fileName:'Sangfor Business Active-active Solution Technical White Paper.pdf',
            fileUrl:'Sangfor Business Active-active Solution Technical White Paper.pdf',
            fileType:'pdf',
          },
          {
            id:7,
            fileName:'Sangfor CDP White Paper.pdf',
            fileUrl:'Sangfor CDP White Paper.pdf',
            fileType:'pdf',
          },
          {
            id:8,
            fileName:'Sangfor HCI & SCP 6.1.0 Technical White Paper.pdf',
            fileUrl:'Sangfor HCI & SCP 6.1.0 Technical White Paper.pdf',
            fileType:'pdf',
          },
          {
            id:9,
            fileName:'Sangfor HCI Instant VM Recovery White Paper.pdf',
            fileUrl:'Sangfor HCI Instant VM Recovery White Paper.pdf',
            fileType:'pdf',
          },
          {
            id:10,
            fileName:'Sangfor HCI Reliability Technical White Paper 20191019 V.2.pdf',
            fileUrl:'Sangfor HCI Reliability Technical White Paper 20191019 V.2.pdf',
            fileType:'pdf',
          },
          {
            id:11,
            fileName:'Sangfor HCI Security White Paper 20200304.pdf',
            fileUrl:'Sangfor HCI Security White Paper 20200304.pdf',
            fileType:'pdf',
          },
          {
            id:12,
            fileName:'Sangfor HCI Storage High Performance Technical White Paper.pdf',
            fileUrl:'Sangfor HCI Storage High Performance Technical White Paper.pdf',
            fileType:'pdf',
          },
        ],
        26:[
          {
            id:1,
            fileName:'DR Bandwidth Calculation Tool.xlsx',
            fileUrl:'DR Bandwidth Calculation Tool.xlsx',
            fileType:'xlsx',
          },
          {
            id:2,
            fileName:'Sangfor aCloud Disaster Recovery Solution Proposal 20190211.docx',
            fileUrl:'Sangfor aCloud Disaster Recovery Solution Proposal 20190211.docx',
            fileType:'doc',
          },
          {
            id:3,
            fileName:'Sangfor aCloud Disaster Recovery Testing Guide ver5.8.6.docx',
            fileUrl:'Sangfor aCloud Disaster Recovery Testing Guide ver5.8.6.docx',
            fileType:'doc',
          },
          {
            id:4,
            fileName:'Sangfor Business Continuity Solution Technical Introduction-v6.pptx',
            fileUrl:'Sangfor Business Continuity Solution Technical Introduction-v6.pptx',
            fileType:'pptx',
          },
          {
            id:5,
            fileName:'Solution_PP_P_Sangfor Data Protection &amp;amp; Disaster Recovery Solution_20200707.pptx',
            fileUrl:'Solution_PP_P_Sangfor Data Protection &amp;amp; Disaster Recovery Solution_20200707.pptx',
            fileType:'pptx',
          },
          {
            id:6,
            fileName:'Veeam Backup and DR Solution 20210402.pptx',
            fileUrl:'Veeam Backup and DR Solution 20210402.pptx',
            fileType:'xlsx',
          },
        ],
        27:[
          {
            id:1,
            fileName:'5.8.3 Sales Training for Partners 0328.pptx',
            fileUrl:'5.8.3 Sales Training for Partners 0328.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'aCloud Disaster Recovery Solution for Technical Discussion.pptx',
            fileUrl:'aCloud Disaster Recovery Solution for Technical Discussion.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Container_PP_P_Container Basic Knowledge_20200924 R2 (1).pptx',
            fileUrl:'Container_PP_P_Container Basic Knowledge_20200924 R2 (1).pptx',
            fileType:'pptx',
          },
          {
            id:4,
            fileName:'Solution_PP_P_Sangfor Data Protection &amp;amp; Disaster Recovery Solution_20200707.pptx',
            fileUrl:'Solution_PP_P_Sangfor Data Protection &amp;amp; Disaster Recovery Solution_20200707.pptx',
            fileType:'pptx',
          },
          {
            id:5,
            fileName:'What New with aCloud 5.8.7R1 aCMP 5.8.6R1.pptx',
            fileUrl:'What New with aCloud 5.8.7R1 aCMP 5.8.6R1.pptx',
            fileType:'pptx',
          },
          {
            id:6,
            fileName:'What New with aCloud 6.0.0 aCMP 6.0.10R1 V.5.pptx',
            fileUrl:'What New with aCloud 6.0.0 aCMP 6.0.10R1 V.5.pptx',
            fileType:'pptx',
          },
          {
            id:7,
            fileName:'What New with SCP(aCMP) HCI(aCloud) 6.1.0 v1.1.pptx',
            fileUrl:'What New with SCP(aCMP) HCI(aCloud) 6.1.0 v1.1.pptx',
            fileType:'pptx',
          },
        ],
        28:[
          {
            id:1,
            fileName:'JEC Sharing for PaaS.pptx',
            fileUrl:'JEC Sharing for PaaS.pptx',
            fileType:'pptx',
          },
          {
            id:2,
            fileName:'MOSTI Project Sharing v3.pptx',
            fileUrl:'MOSTI Project Sharing v3.pptx',
            fileType:'pptx',
          },
          {
            id:3,
            fileName:'Thailand hospital experience sharing.pptx',
            fileUrl:'Thailand hospital experience sharing.pptx',
            fileType:'pptx',
          },
        ],
      },
      fileImg:{
        ppt:require('../../../assets/img/ppt.png'),
        doc:require('../../../assets/img/doc.png'),
        pdf:require('../../../assets/img/pdf.png'),
      }
    };
  },
  methods: {
    handleNodeClick(data) {
      console.log(data);
      if (data.child_id) {
        this.showItem = data.child_id;
        this.mainTitle = data.label;
        this.pagination.total = this.feilIndexData[data.child_id].length;
        this.fileMainItemData = this.feilIndexData[data.child_id];
        this.pagination.data = this.feilIndexData[data.child_id];
        if (this.pagination.total > 8) {
          this.fileMainItemData = this.fileMainItemData.slice(0, 8);
        }
      }else if(data.children&&data.children.length==0){
        this.fileMainItemData =[];
      }
    },
    handleCurrentChange(val) {
      let sliceEnd = val * 8;
      let sliceStart = sliceEnd - 8;
      this.fileMainItemData = this.pagination.data.slice(sliceStart, sliceEnd);
    },
    //初始化渲染
    initRender() {
      if (this.feilIndexData[1].length > 8) {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1].slice(0, 8);
      } else {
        this.pagination.total = this.feilIndexData[1].length;
        this.pagination.data = this.feilIndexData[1];
        this.fileMainItemData = this.feilIndexData[1];
      }
    },
    downFeil(item,type) {
      if(type!='video'){
        var a = document.createElement("a");
        var filename = item;
        a.href =getCurrentHost()+ item;
        a.download = filename;
        a.click();
      }else{
        window.open(item);
      } 
    },
  },
  mounted(){
    this.initRender()
    this.$nextTick(() => {
        this.$refs.tree.setCurrentKey(20)
    })
  }
};
</script>

<style scoped lang="scss">
.hciIndex {
  width: 100%;
  padding: 5px 17px;
  border-radius: 6px;
  display: flex;
  justify-content: space-between;
  .feil_menu {
    width: 20%;
    background: #1688e1;
    .feil_menu_title {
      width: 100%;
      padding: 15px 0;
      font-size: 16px;
      font-weight: 600;
      color: #eaf3f4;
    }
  }
  .feil_main {
    width: 79.5%;
    background: #eff6ff;
    .feil_main_title {
      width: 100%;
      height: 46px;
      background: #1688e1;
      line-height: 46px;
      font-size: 16px;
      text-align: left;
      padding: 0 40px;
      color: #eaf3f4;
    }
    .feil_main_item {
      width: 100%;
      height: 680px;
      padding: 10px;
      .feil_main_item_ul {
        width: 100%;
        .feil_main_item_li {
          padding: 10px;
          .content {
            width: 100%;
            display: flex;
            background: #fff;
            padding: 10px 20px;
            border-radius: 8px;
            justify-content: space-between;
            .content_icon {
              width: 4.5%;
              height: 42px;
              margin-right: 15px;
              background: #248fe6;
              border-radius: 4px;
              display: flex;
              align-items: center;
              justify-content: center;
              img {
                width: 100%;
              }
              .svg-icon {
                font-size: 28px;
                color: #fff;
                font-weight: 600;
              }
            }
            .content_down {
              width: 4%;
              display: flex;
              align-items: center;
              justify-content: center;
              .svg-icon {
                font-size: 24px;
                color: #248fe6;
              }
            }
            .content_title {
              width: 90%;
              display: flex;
              align-items: center;
              font-size: 14px;
              p {
                width: 100%;
                text-align: left;
                color: #248fe6;
                font-weight: 600;
              }
            }
          }
        }
      }
      .noDetail{
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
        flex-direction: column;
        justify-content: center;
        .svg-icon{
          font-size: 60px;
        }
        p{
          font-size: 14px;
        }
      }
    }
  }
}
</style>